module.exports = "<chip label=Vue.js removable></chip>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/chips/removable-chip.vue
 ** module id = 210
 ** module chunks = 0
 **/